import { render, staticRenderFns } from "./MobileExploreDetail.vue?vue&type=template&id=6504b514&scoped=true"
import script from "./MobileExploreDetail.vue?vue&type=script&lang=js"
export * from "./MobileExploreDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileExploreDetail.vue?vue&type=style&index=0&id=6504b514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504b514",
  null
  
)

export default component.exports